import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import { HashRouter, Route } from 'react-router-dom';
import './App.css';
import { Footer, MHeader } from './bundles/common/components';
// import {  Footer } from './bundles/common/components';
import { Home } from './bundles/home/components';
import { PhotoContainer } from './bundles/photogrid/components'
import { Profile } from './bundles/profile/components';

class App extends React.Component {
  constructor(props:any) {
    super(props);
    
    this.getGroups = this.getGroups.bind(this);
    this.getLifestyle = this.getLifestyle.bind(this);
    this.getPublished = this.getPublished.bind(this);
  }

  public handleEvent = (param: any) => (event: any) => {
    const name = param;
    alert('has loaded');
    alert(name);
  }

  public getEvents(): any {
    return (<PhotoContainer page={'events'} loaded={false}/>)
  }
  public getGroups(): any {
    return (<PhotoContainer page={'groups'} loaded={false}/>)
  }  
  public getLifestyle(): any {
    return (<PhotoContainer page={'lifestyle'} loaded={false}/>)
  } 
  public getPortraits(): any {
    return (<PhotoContainer page={'groups'} loaded={false}/>)
  }
  public getPublished(): any {
    return (<PhotoContainer page={'published'} loaded={false}/>)
  }

  public render() {
    return (
      <HashRouter>
        <div className="site">
          <div className="site-content">
            <div className='z2'>
              <Route component={MHeader}/>
            </div>  
            <div className='z1'>
              <Switch>
                <Route exact={true} path="/home" component={Home}/>
                <Route exact={true} path="/photos/events" render={ this.getEvents }/>
                <Route exact={true} path="/photos/groups" render={ this.getGroups }/>
                <Route exact={true} path="/photos/lifestyle" render={ this.getLifestyle }/>
                <Route exact={true} path="/photos/portraits" render={ this.getPortraits }/>
                <Route exact={true} path="/photos/published" render={ this.getPublished }/>
                <Route exact={true} path="/profile" component={ Profile }/>
                <Route path="/*" component={Home}/>
              </Switch>
            </div>
          </div>
          <div className="z3">
            <Route component={ Footer }/>
          </div>
        </div>
      </HashRouter>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.tsx